import request from './axios'

function apiAxios(method, url, params) {
    return request({
        method: method,
        url: url,
        data: params,
        params: method == 'POST' || method == 'PUT' ? "" : params,
        withCredentials: false,
    })
}

export default {
    get: function (url, params) {
        return apiAxios('GET', url, params)
    },
    post: function (url, params) {
        return apiAxios('POST', url, params)
    },
    patch: function (url, params) {
        return apiAxios('PATCH', url, params)
    },
    put: function (url, params) {
        return apiAxios('PUT', url, params)
    },
    delete: function (url, params) {
        return apiAxios('DELETE', url, params)
    }
}